// src/modules/app-views/crm/pages/Boards/tabs/VoipTab/TranscriptionModal.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Modal } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';
import dayjs from 'dayjs';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const TranscriptionModal = props => {
  // ---------------------------------------------------------------------------
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ---------------------------------------------------------------------------
  const { open, onClose, transcription, callInfo } = props;

  // ---------------------------------------------------------------------------
  // 8. UI
  // ---------------------------------------------------------------------------
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={
        <span>
          <FileTextOutlined style={{ marginRight: 8 }} />
          {translateX('goto_transcription')}
        </span>
      }
      width={600}
    >
      {/* Call info header */}
      {callInfo && (
        <div
          style={{
            marginBottom: 12,
            paddingBottom: 12,
            borderBottom: '1px solid var(--ant-color-border)',
            fontSize: 13,
            color: 'var(--ant-color-text-secondary)',
          }}
        >
          <strong>{callInfo.collaboratorName || callInfo.from || callInfo.to || '-'}</strong>
          {callInfo.initiatedAt && (
            <span style={{ marginLeft: 8 }}>
              {dayjs(callInfo.initiatedAt).format('DD/MM/YYYY HH:mm')}
            </span>
          )}
        </div>
      )}

      {/* Transcription body */}
      <div
        style={{
          whiteSpace: 'pre-wrap',
          maxHeight: '60vh',
          overflowY: 'auto',
          fontSize: 14,
          lineHeight: 1.6,
        }}
      >
        {transcription || translateX('goto_no_transcription')}
      </div>
    </Modal>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default TranscriptionModal;
